export default __webpack_public_path__ + "static/media/inactiveService.82da3628.png";